import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
  {
    id: 'timer',
    path: '/',
    label: 'Focus',
    icon: () => (
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
  },
  {
    id: 'garden',
    path: '/garden',
    label: 'Garden',
    icon: () => (
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="14" r="5" />
        <path d="M12 9 Q10 5 8 4" />
        <path d="M12 9 Q14 5 16 4" />
        <line x1="12" y1="19" x2="12" y2="22" />
      </svg>
    ),
  },
  {
    id: 'stats',
    path: '/stats',
    label: 'Stats',
    icon: () => (
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
      </svg>
    ),
  },
  {
    id: 'profile',
    path: '/profile',
    label: 'Profile',
    icon: () => (
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
];

export default function BottomNav({ hidden = false }) {
  const location = useLocation();
  const navigate = useNavigate();

  if (hidden) return null;

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-[100] flex items-center justify-around safe-area-bottom h-[68px] backdrop-blur-glass [backdrop-filter:blur(24px)_saturate(1.5)] [-webkit-backdrop-filter:blur(24px)_saturate(1.5)] bg-cream-50/75 dark:bg-soil-200/75 border-t border-tomato-500/10 dark:border-tomato-500/10"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)', height: 'calc(68px + env(safe-area-inset-bottom))' }}
      aria-label="Main navigation"
    >
      {NAV_ITEMS.map((item) => {
        const isActive = location.pathname === item.path;
        return (
          <button
            key={item.id}
            className={[
              'relative flex flex-col items-center justify-center gap-[3px] px-5 py-2 min-w-[64px] min-h-[48px] rounded-[10px] transition-all duration-150 bg-transparent border-0 cursor-pointer',
              isActive
                ? 'opacity-100 text-tomato-600 dark:text-tomato-500'
                : 'opacity-60 text-cream-500 dark:text-cream-500 hover:opacity-80 hover:bg-tomato-500/5',
              isActive && 'after:content-[""] after:absolute after:bottom-0.5 after:left-1/2 after:-translate-x-1/2 after:w-1 after:h-1 after:rounded-full after:bg-tomato-600 dark:after:bg-tomato-500 after:shadow-[0_0_8px_currentColor]',
            ].filter(Boolean).join(' ')}
            onClick={() => navigate(item.path)}
            aria-current={isActive ? 'page' : undefined}
            aria-label={item.label}
          >
            {item.icon(isActive)}
            <span className="text-[10px] font-semibold tracking-wide">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
